module.exports = __webpack_public_path__ + "media/images/flags/4x3/esp-9022b6f140f42459141768b3cc241a3f.svg";